<main>
  <div class="hero_single inner_pages background-image">
    <div class="opacity-mask">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h1>Oh My Menu</h1>
            <p>{{ "Home.HeroClaim" | translate }}</p>
            <a
              href="https://admin.ohmymenu.com/register?overwrite_language={{i18n.currentLang}}"
              class="btn_1 gradient btn_scroll"
            >
              {{ "Home.FreeTrial" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wave hero"></div>
  </div>

  <div class="container margin_30_20">
    <div class="main_title center">
      <span><em></em></span>
      <h2>{{ "Home.H2" | translate }}</h2>
      <p>{{ "Home.H2Claim" | translate }}</p>
    </div>

    <div class="row justify-content-center align-items-center add_bottom_15">
      <div class="col-lg-6">
        <div class="box_about">
          <h3>{{ "Home.H3Bullet1" | translate }}</h3>
          <p class="lead">{{ "Home.H3Bullet1Claim" | translate }}</p>
          <p>{{ "Home.H3Bullet1P1" | translate }}</p>
          <p>{{ "Home.H3Bullet1P2" | translate }}</p>
          <img
            src="assets/img/arrow_about.png"
            loading="lazy"
            alt="curved arrow"
            class="arrow_1"
          />
        </div>
      </div>
      <div class="col-lg-6 text-center d-none d-lg-block">
        <img
          src="assets/img/about_1.svg"
          loading="lazy"
          alt="People working"
          class="img-fluid"
          width="450"
          height="450"
        />
      </div>
    </div>

    <div class="row justify-content-center align-items-center add_bottom_15">
      <div class="col-lg-6 text-center d-none d-lg-block">
        <img
          src="assets/img/about_2.svg"
          loading="lazy"
          alt="Man using digital tool"
          class="img-fluid"
          width="450"
          height="450"
        />
      </div>
      <div class="col-lg-6">
        <div class="box_about">
          <h3>{{ "Home.H3Bullet2" | translate }}</h3>
          <p class="lead">{{ "Home.H3Bullet2Claim" | translate }}</p>
          <p>{{ "Home.H3Bullet2P1" | translate }}</p>
          <p>{{ "Home.H3Bullet2P2" | translate }}</p>
          <img
            src="assets/img/arrow_about.png"
            loading="lazy"
            alt="curved arrow"
            class="arrow_2"
          />
        </div>
      </div>
    </div>

    <div class="row justify-content-center align-items-center">
      <div class="col-lg-6">
        <div class="box_about">
          <h3>{{ "Home.H3Bullet3" | translate }}</h3>
          <p class="lead">{{ "Home.H3Bullet3Claim" | translate }}</p>
          <p>{{ "Home.H3Bullet3P1" | translate }}</p>
          <p>{{ "Home.H3Bullet3P2" | translate }}</p>
        </div>
      </div>
      <div class="col-lg-6 text-center d-none d-lg-block">
        <img
          src="assets/img/about_3.svg"
          loading="lazy"
          alt="Man using a mobile device"
          class="img-fluid"
          width="450"
          height="450"
        />
      </div>
    </div>
  </div>

  <div class="bg_gray">
    <div class="container margin_60_40">
      <div class="main_title center">
        <span><em></em></span>
        <h2>{{ "Home.OurPrices" | translate }}</h2>
        <p>{{ "Home.OurPricesClaim" | translate }}</p>
      </div>
      <div class="row plans">
        <div class="plan col-md-3 plan-tall">
          <div class="plan-title">
            <h3>BASIC</h3>
          </div>
          <p class="plan-price">0.99€</p>
          <ul class="plan-features">
            <li>{{ "Home.BASIC.Advantage1" | translate }}</li>
            <li>{{ "Home.BASIC.Advantage2" | translate }}</li>
            <li>{{ "Home.BASIC.Advantage3" | translate }}</li>
            <li>{{ "Home.BASIC.Advantage4" | translate }}</li>
            <li>{{ "Home.BASIC.Advantage5" | translate }}</li>
          </ul>
          <a
            href="https://admin.ohmymenu.com/register?selected_plan=BASIC&overwrite_language={{i18n.currentLang}}"
            class="btn_1 gradient btn_scroll"
          >
            {{ "Home.StartNow" | translate }}
          </a>
        </div>

        <div class="plan col-md-3 plan-tall">
          <div class="plan-title">
            <h3>LITE</h3>
          </div>
          <p class="plan-price">2.99€</p>
          <ul class="plan-features">
            <li>{{ "Home.LITE.Advantage1" | translate }}</li>
            <li>{{ "Home.LITE.Advantage2" | translate }}</li>
            <li>{{ "Home.LITE.Advantage3" | translate }}</li>
            <li>{{ "Home.LITE.Advantage4" | translate }}</li>
            <li>{{ "Home.LITE.Advantage5" | translate }}</li>
          </ul>
          <a
            href="https://admin.ohmymenu.com/register?selected_plan=LITE&overwrite_language={{i18n.currentLang}}"
            class="btn_1 gradient btn_scroll"
          >
            {{ "Home.StartNow" | translate }}
          </a>
        </div>

        <div class="plan col-md-3">
          <div class="plan-title">
            <h3>PREMIUM</h3>
          </div>
          <p class="plan-price">9.99€</p>
          <ul class="plan-features">
            <li>{{ "Home.PREMIUM.Advantage1" | translate }}</li>
            <li>{{ "Home.PREMIUM.Advantage2" | translate }}</li>
            <li>{{ "Home.PREMIUM.Advantage3" | translate }}</li>
            <li>{{ "Home.PREMIUM.Advantage4" | translate }}</li>
            <li>{{ "Home.PREMIUM.Advantage5" | translate }}</li>
          </ul>
          <button class="btn_1 gradient btn_scroll disabled">
            {{ "Home.CommingSoon" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
